export default {
	accountShareHoldings: null,
	tradingHours: {
		options: {
			closing_hour: null,
			opening_hour: null,
		},
	}
}
